var map = {
	"./class_druid.jpg": 73903,
	"./class_hunter.jpg": 22813,
	"./class_mage.jpg": 9378,
	"./class_paladin.jpg": 18736,
	"./class_priest.jpg": 28514,
	"./class_rogue.jpg": 99857,
	"./class_shaman.jpg": 93072,
	"./class_warlock.jpg": 88788,
	"./class_warrior.jpg": 28434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3991;